import React, { useEffect } from "react";
import "./Slider.css";

const Slider = ({ sliderImages }) => {

  const isMobile = window.innerWidth <= 576;

  const getOptimizedImage = (url, width, mobile = false) => {
    if (!url?.includes("cloudinary.com")) return url;

    const height = Math.round(width / 4);
    const dpr = mobile ? "1.5" : "2";

    return url.replace(
      "/upload/",
      `/upload/w_${width},h_${height},c_fill,f_auto,q_auto:eco,dpr_${dpr}/`
    );
  };

  useEffect(() => {
    const carouselElement = document.getElementById("esevaSlider");
    if (!carouselElement || !window.bootstrap || !sliderImages?.length) return;

    const bsCarousel =
      window.bootstrap.Carousel.getInstance(carouselElement) ||
      new window.bootstrap.Carousel(carouselElement);

    const imgs = carouselElement.querySelectorAll("img");

    imgs.forEach((img) => {
      const pause = () => bsCarousel.pause();
      const play = () => bsCarousel.cycle();

      img.addEventListener("touchstart", pause, { passive: true });
      img.addEventListener("touchend", play);
      img.addEventListener("mousedown", pause);
      img.addEventListener("mouseup", play);
    });

  }, [sliderImages]);

  return (
    <div
      id="esevaSlider"
      className="carousel slide"
      data-bs-ride="carousel"
      data-bs-interval="2500"
      data-bs-pause="false"
    >
      <div className="carousel-inner">
        {sliderImages?.length === 0 ? (
          <div className="carousel-item active">
            <div className="slider-img-wrapper ratio-box placeholder-skeleton">
              <p>Loading Content...</p>
            </div>
          </div>
        ) : (
          sliderImages.map((img, i) => (
            <div
              key={img._id}
              className={`carousel-item ${i === 0 ? "active" : ""}`}
            >
              <div className="slider-img-wrapper ratio-box">

                <picture>
                  {/* Mobile */}
                  <source
                    media="(max-width: 576px)"
                    srcSet={getOptimizedImage(img.imageUrl, 480, true)}
                  />

                  {/* Tablet */}
                  <source
                    media="(max-width: 992px)"
                    srcSet={getOptimizedImage(img.imageUrl, 900)}
                  />

                  {/* Desktop */}
                  <source
                    media="(min-width: 993px)"
                    srcSet={getOptimizedImage(img.imageUrl, 1400)}
                  />

                  {/* Fallback must be mobile size */}
                  <img
                    alt="ESevaLink slider"
                    src={getOptimizedImage(img.imageUrl, 480, true)}
                    className="slider-img-responsive"
                    loading="lazy"
                    fetchpriority="low"
                    decoding="async"
                    width="360"
                    height="90"
                  />
                </picture>

                <div className="slider-timer-bar"></div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Slider;
